import React, { useState } from "react";

// Package Import
import {
  Typography,
  Box,
  useTheme,
  TextField,
  Button,
  Grid,
  Paper,
  MenuItem,
  Backdrop,
  Alert,
  Snackbar,
  CircularProgress,
} from "@mui/material";
import { formControlClasses } from "@mui/material/FormControl";
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { Add as AddIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import DatePicker from "react-datepicker";

// User Import

import { headersPost } from "../../../../Services/API";
import { PROVINCE_API_ULRS } from "../../../../Services/Routes/API";
import { RoutesUrls } from "../../../../Services/Routes/APP";
import {
  RequestEnumArr,
  BATCH_MAIN_TYPES_ENUM_ARRAY,
  BATCH_SUB_TYPES_ENUM_ARRAY,
} from "../../../../common/Enums";
import { CustomDateInput } from "../../../../common/Components";
import { requestToSchema } from "../../../../Services/validations/MinistryPortal/Request";

// constant

const initialValues = {
  main_type: "",
  sub_type: "",
  request_type: "",
  receiver_id: "",
  quantity: "",
  delivery_date: "",
  note: "",
};

// Component

const RequestBatch = () => {
  // Hooks
  const theme = useTheme();
  const navigate = useNavigate();

  //states

  const [open, setOpen] = useState(false);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [recieverArr, setRecieverArr] = useState([]);

  // form submit handller

  const formSubmitHanlder = (values) => {
    const data = {
      requests: {
        main_type: values.main_type,
        sub_type: values.sub_type,
        request_type: values.request_type,
        receiver_id: values.receiver_id,
        quantity: values.quantity,
        delivery_date: values.delivery_date,
        note: values.note,
      },
    };
    setOpen(true);

    headersPost(PROVINCE_API_ULRS.CREATE_REQUEST, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("success");
          navigate(-1);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //

  const getTypeHandler = (type) => {
    const data = {
      requests: {
        request_type: type,
      },
    };
    setOpen(true);

    headersPost(PROVINCE_API_ULRS.REQUEST_INVENTORY, data)
      .then((res) => {
        setOpen(false);
        if (res?.status === 200 && res?.data?.success) {
          setRecieverArr(res?.data?.receiver);
        } else {
          setAlertOpen(true);
          setAlertMsg(res?.data?.message);
          setAlertIcon("warning");
        }
      })
      .catch((err) => {
        setOpen(false);
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
          setAlertOpen(true);
          setAlertMsg(response?.statusText);
          setAlertIcon("error");
        }
      });
  };

  //close alert

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setAlertOpen(false);
  };
  // Render
  return (
    <Paper
      sx={{
        p: 2,
        margin: "auto",

        borderRadius: 2,
      }}
    >
      <Box padding={2}>
        <Typography
          width={"100%"}
          variant="h5"
          fontWeight={"bold"}
          display={"flex"}
          justifyContent={"center"}
          color={"text.grayText"}
          sx={{
            textTransform: "uppercase",
            paddingBottom: 2,
          }}
        >
          Request Inventory
        </Typography>
        <Formik
          initialValues={initialValues}
          onSubmit={formSubmitHanlder}
          validationSchema={requestToSchema}
          enableReinitialize
        >
          {({
            values,
            touched,
            errors,
            handleChange,
            handleSubmit,
            setFieldValue,
          }) => (
            <Form onSubmit={handleSubmit}>
              <Box padding={{ xs: 2, sm: 3, md: 5 }}>
                <Grid
                  container
                  justifyContent={"space-around"}
                  spacing={2}
                  margin={"auto"}
                  maxWidth={350}
                >
                  {/* main type */}

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="main_type"
                      value={values?.main_type}
                      select
                      error={touched?.main_type && Boolean(errors?.main_type)}
                      helperText={touched?.main_type && errors?.main_type}
                      fullWidth
                      SelectProps={{
                        displayEmpty: true,
                      }}
                      onChange={handleChange}
                      // sx={{
                      //   border: "1px solid grey",
                      //   [`& .${outlinedInputClasses?.root}`]: {
                      //     borderRadius: theme.spacing(4),
                      //   },
                      //   [`&.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    >
                      <MenuItem value={""} disabled>
                        Select an inventory type
                      </MenuItem>
                      {BATCH_MAIN_TYPES_ENUM_ARRAY?.map((item, index) => (
                        <MenuItem
                          value={item.value}
                          key={`${index}-request-inventory-${item.value}`}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  {/* subtype */}
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      type={"text"}
                      name="sub_type"
                      value={values?.sub_type}
                      error={touched?.sub_type && Boolean(errors?.sub_type)}
                      helperText={touched?.sub_type && errors?.sub_type}
                      select
                      fullWidth
                      SelectProps={{
                        displayEmpty: true,
                      }}
                      onChange={handleChange}
                      // sx={{
                      //   border: "1px solid grey",
                      //   [`& .${outlinedInputClasses?.root}`]: {
                      //     borderRadius: theme.spacing(4),
                      //   },
                      //   [`&.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    >
                      <MenuItem value={""} disabled>
                        Select Category
                      </MenuItem>
                      {BATCH_SUB_TYPES_ENUM_ARRAY?.map((item, index) => (
                        <MenuItem
                          value={item.value}
                          key={`${index}-request-inventory-${item.value}`}
                        >
                          {item.name}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  {/* Email */}
                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      fullWidth
                      select
                      SelectProps={{
                        displayEmpty: true,
                      }}
                      name="request_type"
                      onChange={(e) => {
                        getTypeHandler(e.target.value);
                        setFieldValue("request_type", e.target.value);
                      }}
                      type={"text"}
                      value={values?.request_type}
                      error={
                        touched?.request_type && Boolean(errors?.request_type)
                      }
                      helperText={touched?.request_type && errors?.request_type}
                      placeholder="Select Type"
                      // sx={{
                      //   border: "1px solid grey",
                      //   [`& .${outlinedInputClasses?.root}`]: {
                      //     borderRadius: theme.spacing(4),
                      //   },
                      //   [`&.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    >
                     <MenuItem value={""} disabled>
                        Select Type{" "}
                      </MenuItem>
                      {RequestEnumArr?.map((item, index) => (
                        <MenuItem
                          key={`${index}-request-${item.value}`}
                          value={item.value}
                        >
                          {item.name}{" "}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      fullWidth
                      select
                      SelectProps={{
                        displayEmpty: true,
                      }}
                      name="receiver_id"
                      onChange={handleChange}
                      type={"text"}
                      value={values?.receiver_id}
                      error={
                        touched?.receiver_id && Boolean(errors?.receiver_id)
                      }
                      helperText={touched?.receiver_id && errors?.receiver_id}
                      // sx={{
                      //   border: "1px solid grey",
                      //   [`& .${outlinedInputClasses?.root}`]: {
                      //     borderRadius: theme.spacing(4),
                      //   },
                      //   [`&.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    >
                      <MenuItem value={""} disabled>
                        Request to
                      </MenuItem>
                      {recieverArr?.map((item, index) => (
                        <MenuItem
                          key={`${index}-request-${item.id}`}
                          value={item.id}
                        >
                          {item.name}{" "}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>

                  <Grid container marginBottom={5}>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      placeholder="Quantity"
                      name="quantity"
                      onChange={handleChange}
                      type={"number"}
                      value={values?.quantity}
                      error={touched?.quantity && Boolean(errors?.quantity)}
                      helperText={touched?.quantity && errors?.quantity}
                      fullWidth
                      // sx={{
                      //   border: "1px solid grey",
                      //   [`& .${outlinedInputClasses?.root}`]: {
                      //     borderRadius: theme.spacing(4),
                      //   },
                      //   [`&.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      // }}
                    />
                  </Grid>
                  <Grid container marginBottom={5}>
                    <DatePicker
                      selected={values.delivery_date}
                      onChange={(date) => setFieldValue("delivery_date", date)}
                      minDate={new Date()}
                      selectsStart
                      placeholderText="Required by date"
                      name="delivery_date"
                      customInput={
                        <CustomDateInput
                          size={"small"}
                          name={"delivery_date"}
                          InputProps={{
                            readOnly: true,
                          }}
                          helperText={
                            touched?.delivery_date && errors?.delivery_date
                          }
                          error={
                            touched?.delivery_date &&
                            Boolean(errors?.delivery_date)
                          }
                        />
                      }
                    />
                  </Grid>
                  {/* Domain */}
                  <Grid container>
                    <TextField
                      variant="outlined"
                      size={"small"}
                      rows={3}
                      type={"text"}
                      name="note"
                      onChange={handleChange}
                      error={touched?.note && Boolean(errors?.note)}
                      helperText={touched?.note && errors?.note}
                      value={values.note}
                      multiline
                      placeholder="Request Description"
                      fullWidth
                      // sx={{
                      //   border: "1px solid grey",
                      //   borderRadius: theme.spacing(1),

                      //   [`&.${formControlClasses?.root}`]: {
                      //     border: "none",
                      //   },
                      //   [`& .${outlinedInputClasses?.root}`]: {
                      //     borderRadius: theme.spacing(2),
                      //   },
                      // }}
                    />
                    <Grid
                      container
                      marginTop={5}
                      display={"flex"}
                      justifyContent={"center"}
                    >
                      <Button
                        variant="contained"
                        type="submit"
                        size="large"
                        margin={"auto"}
                        sx={{
                          // borderRadius: "37px !important",
                          minWidth: "20%",
                        }}
                      >
                        {" "}
                        Request{" "}
                      </Button>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </Form>
          )}
        </Formik>
      </Box>
      <Backdrop
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: theme.palette.primary.main,
        }}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </Paper>
  );
};

export default RequestBatch;
